import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NxButtonModule } from '@aposin/ng-aquila/button';
import { FORMFIELD_DEFAULT_OPTIONS, FormfieldDefaultOptions, NxFormfieldModule } from '@aposin/ng-aquila/formfield';
import { NxHeadlineModule } from '@aposin/ng-aquila/headline';
import { NxInputModule } from '@aposin/ng-aquila/input';
import { NxMessageModule } from '@aposin/ng-aquila/message';
import { NxSpinnerModule } from '@aposin/ng-aquila/spinner';
import { TranslateModule } from '@ngx-translate/core';

import { ESG_GERL_QUIZ_COMMENT_TEMPLATE, esgGerlQuizCommentChangedValidator } from '#data/esg-gerl-quiz-comment';
import CveService from '#services/cve/cve.service';

const formfieldDefaultOptions: FormfieldDefaultOptions = {
  appearance: 'outline',
  nxFloatLabel: 'always',
};

@Component({
  selector: 'kyc-esg-quiz-update-fragment',
  imports: [
    NxHeadlineModule,
    NxFormfieldModule,
    FormsModule,
    NxInputModule,
    ReactiveFormsModule,
    NxButtonModule,
    NxMessageModule,
    NxSpinnerModule,
    TranslateModule,
  ],
  providers: [{ provide: FORMFIELD_DEFAULT_OPTIONS, useValue: formfieldDefaultOptions }],
  templateUrl: './esg-quiz-update-fragment.component.html',
})
export class EsgQuizUpdateFragmentComponent {
  private readonly fb = inject(FormBuilder);
  private readonly cveService = inject(CveService);
  private readonly iterationSignal = toSignal(this.cveService.iterationData$);
  protected readonly formGroup = this.fb.group({
    esgGerlQuizComment: [
      this.iterationSignal()?.customProperties.esgGerlQuizComment ?? ESG_GERL_QUIZ_COMMENT_TEMPLATE,
      [Validators.required, esgGerlQuizCommentChangedValidator],
    ],
  });
  protected loading = false;
  protected async submit() {
    const iterationData = this.iterationSignal();
    if (!iterationData) throw new Error('No iteration data');
    this.loading = true;
    await this.cveService.patchIteration(iterationData.iterationId, {
      customProperties: { esgGerlQuizComment: this.formGroup.value.esgGerlQuizComment },
    });
    this.loading = false;
  }
}
